const type = {
	EMAIL: 1,
  SMS: 2,
  WHATSAPP: 3,
  PUSH: 4,
}

export default type;
